const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d44141;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M24.533,3.848H21.077V2a2,2,0,0,0-2-2h-6.15a2,2,0,0,0-2,2V3.848H7.468A4.267,4.267,0,0,0,3.206,8.109v2.756a.492.492,0,0,0,.492.492H4.706L5.728,31.506a.49.49,0,0,0,.491.467h19.7a.493.493,0,0,0,.492-.471l.845-20.145H28.3a.492.492,0,0,0,.492-.492V8.109A4.266,4.266,0,0,0,24.533,3.848ZM11.907,2A1.019,1.019,0,0,1,12.925.984h6.15A1.019,1.019,0,0,1,20.093,2V3.848H11.907ZM25.444,30.989H6.687l-1-19.632H26.268ZM27.81,10.373H4.19V8.109A3.281,3.281,0,0,1,7.468,4.832H24.533A3.28,3.28,0,0,1,27.81,8.109Z",
  transform: "translate(-3.206)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M11.225,27.011a.492.492,0,0,0,.492-.492V12.883a.492.492,0,0,0-.984,0V26.519A.492.492,0,0,0,11.225,27.011Z",
  transform: "translate(-3.206)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15.962,27.011a.491.491,0,0,0,.491-.492V12.883a.491.491,0,0,0-.983,0V26.519A.492.492,0,0,0,15.962,27.011Z",
  transform: "translate(-3.206)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.835,27.011a.492.492,0,0,0,.492-.492V12.883a.492.492,0,0,0-.984,0V26.519A.492.492,0,0,0,20.835,27.011Z",
  transform: "translate(-3.206)"
});
function SvgRecbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.588,
    height: 31.973,
    viewBox: "0 0 25.588 31.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecbin);
export default __webpack_public_path__ + "static/media/recbin.0d444f9ab75d0489f499fd71ce18e59a.svg";
export { ForwardRef as ReactComponent };